import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

/*
  Pipe for marking data binded url string as safe only for trusted input like youtube.com
*/

@Pipe({
  name: 'safe',
  standalone: true,
})
export class SafePipe implements PipeTransform {
  sanitizer: DomSanitizer = inject(DomSanitizer);

  private isTrustedUrl(url: string): boolean {
    // Example: Allow only HTTPS URLs and specific trusted domains
    try {
      const parsedUrl = new URL(url);
      return (
        parsedUrl.protocol === 'https:' &&
        (parsedUrl.hostname.includes('youtube.com') ||
          parsedUrl.host.includes('johnstonsgrain.com'))
      );
    } catch (e) {
      return false; // Invalid URL
    }
  }

  transform(value: string): SafeResourceUrl | null {
    if (!value || !this.isTrustedUrl(value)) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
}
